'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var keys = ['resourceUrl', 'connectType', 'type', 'timestamp', 'requestbyte', 'responsebyte', 'responsetime', 'project', 'pageUrl', 'realUrl', 'statusCode', 'firstCategory', 'secondCategory', 'logContent', 'traceid', 'ctags'];
var uploadKeys = keys;

/**
 * 资源信息数据模型
 * 
 * @param {string} project - 资源所在项目
 * @param {string} pageUrl - 资源聚合页面地址
 * @param {string} realUrl - 页面真实地址
 * @param {string} resourceUrl - 资源的名称，通常是url，也可以是其他字符串
 * @param {String} type - 资源类型,包括link,script,img,ajax,api
 * @param {Number} timestamp - 时间戳
 * @param {Number} requestbyte - 资源请求大小
 * @param {Number} responsebyte - 资源响应大小
 * @param {Number} responsetime - 资源响应时间
 * @param {string} statusCode - 资源状态码, 格式为：'网络状态码|业务状态码', 一般有一个状态码即可
 * @param {string} firstCategory - 资源出错时的错误分类
 * @param {string} secondCategory - 资源出错时的子分类
 * @param {string} logContent - 资源出错时的详情
 * @param {string} traceid
 * 
 * @class ResourceModel
 */

var ResourceModel = function () {
    function ResourceModel(data) {
        var _this = this;

        _classCallCheck(this, ResourceModel);

        keys.forEach(function (key) {
            _this[key] = data[key];
        });
        this.parse();
    }

    _createClass(ResourceModel, [{
        key: 'parse',
        value: function parse() {
            this.timestamp = this.timestamp || Date.now().toString();
            this.requestbyte = this.requestbyte || '0';
            this.responsebyte = this.responsebyte || '0';
        }
    }, {
        key: 'update',
        value: function update(obj) {
            for (var key in obj) {
                if (obj.hasOwnProperty(key) && keys.indexOf(key) > -1) {
                    this[key] = obj[key];
                }
            }
        }
    }, {
        key: 'stringify',
        value: function stringify() {
            var _this2 = this;

            var ret = uploadKeys.map(function (key) {
                return _this2[key];
            });
            return ret.join('\t');
        }
    }]);

    return ResourceModel;
}();

module.exports = ResourceModel;